import { Container, Graphics, Text } from "pixi.js"
import { STOREY_RISE_PX, ROOF_UPLIFT_PX } from "game-common/room/ember/two_storey_house"
import { isBuildingHeightTuningEnabled } from "../../../../building_debug_access"

/** Screen-fixed readout for live building-height tuning. */
export class StoreyRiseDebug extends Container {
    private label: Text
    private displayedRise?: number
    private displayedUplift?: number

    constructor() {
        super()
        this.visible = false
        this.zIndex = 10000000
        this.interactive = this.interactiveChildren = false
        this.pivot.set(220, 92)
        const background = new Graphics()
        background.beginFill(0x101820, 0.9)
        background.lineStyle(1, 0x68808f, 0.8)
        background.drawRoundedRect(0, 0, 220, 92, 6)
        background.endFill()
        this.label = new Text("", { fontFamily: "monospace", fontSize: 12, fill: 0xffffff, lineHeight: 18 })
        this.label.position.set(12, 9)
        this.addChild(background, this.label)
    }

    update(width: number, height: number, playerName?: string): void {
        this.visible = isBuildingHeightTuningEnabled(playerName)
        if (!this.visible) return
        if (this.displayedRise !== STOREY_RISE_PX || this.displayedUplift !== ROOF_UPLIFT_PX) {
            this.displayedRise = STOREY_RISE_PX
            this.displayedUplift = ROOF_UPLIFT_PX
            this.label.text = `Rise: ${STOREY_RISE_PX}px\n- / = adjust rise\nRoof uplift: ${ROOF_UPLIFT_PX}px\n_ / + adjust uplift`
        }
        if (this.parent) {
            this.scale.set(1 / this.parent.scale.x, 1 / this.parent.scale.y)
            this.position.copyFrom(this.parent.toLocal({ x: width - 12, y: height - 12 } as any))
        }
    }
}
